'use client'

import { useSetAtom } from 'jotai'
import { useCallback } from 'react'

import { useWidgetComponentKey } from '@/features/dashboard/hooks/use-widget-component-key'
import { TUTORIALS } from '@/features/tutorial/lib/tutorials'
import { tutorialRequestAtom } from '@/state/tutorial'

/**
 * Opens the tutorial for a placed widget, found by its instance id. Returns null when the
 * widget (or its kind) has no tutorial, so the menu can leave the row out.
 */
export function useOpenWidgetTutorial(cardId: string): (() => void) | null {
  const setRequest = useSetAtom(tutorialRequestAtom)
  const componentKey = useWidgetComponentKey(cardId)

  const open = useCallback(() => {
    if (componentKey && componentKey in TUTORIALS) {
      setRequest({ id: componentKey as keyof typeof TUTORIALS, source: 'widget', cardId })
    }
  }, [cardId, componentKey, setRequest])

  return componentKey && componentKey in TUTORIALS ? open : null
}
